import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoading: false,

    //to retain the search filter upon redirecting to new page
    schoolFilter: {
      schoolName: "",
      status: ""
    },

    instructorFilter: {
      schoolId: "",
      instructorName: "",
      userTypeName: "",
      status: ""
    },

    studentFilter: {
      schoolId: "",
      studentName: "",
      status: ""
    },

    classFilter: {
      schoolId: "",
      subjectName: "",
      subjectLevelName: "",
      duration: "",
      frequency: "",
      locationId: "",
      startDate: "",
      endDate: "",
      startTimeHour: "",
      startTimeMinute: "",
      startTimePart: "AM",
      endTimeHour: "",
      endTimeMinute: "",
      endTimePart: "AM",
      availability: "",
      instructorName: "",
      selectedDate: "",
      selectedView: "",
      format: ""
    },

    classBookingFilter: {
      schoolId: "",
      subjectName: "",
      subjectLevelName: "",
      duration: "",
      makeupClass: "",
      studentName: "",
      instructorName: "",
      startDate: "",
      endDate: "",
      startTimeHour: "",
      startTimeMinute: "",
      startTimePart: "AM",
      endTimeHour: "",
      endTimeMinute: "",
      endTimePart: "AM",
      statuses: [],
      selectedDate: "",
      selectedView: "",
      format: ""
    },

    documentFilter: {
      schoolId: "",
      name: "",
      userTypeName: ""
    },

    errorReportFilter: {
      submittedDateFrom: "",
      submittedDateTo: ""
    },

    class: {
      classId: "",
      date: "",
      time: "",
      instructorId: "",
      instructorName: ""
    },

    studentCountry: "",
    expandSidebar: true
  }
})


// WEBPACK FOOTER //
// ./src/store.js